<template>
  <div class="Writing">
    <div><h2 class="Title">发布文章</h2></div>
    <div>
      <form>
        <span>标题<input name="title" v-model="title"></input></span>
        <span>标签<select><option value="算法">算法</option><option value="论文">论文</option><option
            value="竞赛">竞赛</option></select></span>
        <span><div class="TextEditor"><textarea placeholder="正文" ref="TextEditor"
                                                v-model="content"
                                                :style="Style.ContentStyle" v-text="content"></textarea><span
            class="Menu" :style="Style.MenuStyle"><b v-for="content in Label"
                                                               v-on:click="Add(content.LabelPair)"
                                                               v-html="content.Text"></b><b v-on:click="Reset"><i
            class="fa fa-eraser"></i></b></span></div><pre class="Visualizer"
                                                           :style="Style.HtmlcontentStyle"
                                                           v-html="content"></pre></span>

        <span><button>发布</button></span>
      </form>
    </div>
  </div>
</template>

<script>
var Style = {
  ContentStyle: "",
  HtmlcontentStyle: "",
  MenuStyle: "",
};
var Label = {
  h1: {
    Text: "h1",
    LabelPair: "<h1></h1>"
  },
  p: {
    Text: "p",
    LabelPair: "<p></p>"
  },
  img: {
    Text: "<i class='fa fa-image'></i>",
    LabelPair: "<img src='https://images.ptausercontent.com/57148679-d574-4f49-b048-775c6c07791c.jpg'>"
  },
  code: {
    Text: "<i class='fa fa-code'></i>",
    LabelPair: "<code></code>"
  },
  a: {
    Text: "<i class='fa fa-link'></i>",
    LabelPair: "<a href=''></a>"
  }
}
export default {
  name: "Writing",
  data() {
    return {
      Style: Style,
      Label: Label,
      title: '',
      content: '',
    }
  },
  methods: {
    Add: function (addcontent) {
      this.content += addcontent + '\n';
    },
    Reset: function () {
      this.content = "";
      this.$refs.TextEditor.style.minHeight = "305px";
    }
  },
  watch: {
    content: function () {
      this.$refs.TextEditor.style.minHeight = this.$refs.TextEditor.scrollHeight + "px";
      if (this.content === "") {//监听事件优先于Reset中的重置高度事件，因此需要再进行一次高度重置。
        this.Reset();
      }

    }
  }
}
</script>

<style>
.Writing {
  width: 80%;
  height: auto;
  padding: 20px 10%;
  background-color: white;
  text-align: center;
  margin-bottom: 100px;
  opacity: 0.8;
}

.Writing .Title {
  text-align: center;
  padding: 20px 0;
}

.Writing form {
  height: auto;
  font-size: 1.2em;
}

.Writing form span {
  height: auto;
  display: block;
  margin: 20px auto;
}

.Writing form input {
  background-color: whitesmoke;
  border: none;
  border-radius: 10px;
  margin-left: 10px;
  text-indent: 1em;
  height: 40px;
}

.TextEditor, .Visualizer {
  width: 40%;
  min-height: 400px;
  height: auto;
  background-color: white;
  border-radius: 10px;
  padding: 1% 2%;
  border: 1px solid gray;
  transition: 0s;
  display: inline-block;
  margin: 0 10px;
  vertical-align: bottom;
}

.TextEditor textarea {
  width: 95%;
  padding: 10px 2.5%;
  min-height: 305px;
  border: 2px solid black;
  font-size: 0.9em;
  line-height: 2em;
  border-radius: 10px;
  word-break: break-all;
  overflow-y: hidden;
}

.TextEditor {
}

.Visualizer {
  text-align: left;
}

.Visualizer h1 {
  text-align: left;
  color: deepskyblue;
}

.Visualizer p {
  text-align: left;
  text-indent: 2em;
}

.Visualizer a {
  color: limegreen;
  text-decoration: underline;
}

.Visualizer img {
  display: block;
  width: 20%;
  margin: 0 auto;
  border-radius: 5px;
  box-shadow: 0.2px 0.2px 20px black;
}

.Writing .Menu {
  width: 98%;
  padding: 0 1%;
  height: 40px;
  line-height: 30px;
  text-align: left;
  display: inline-block;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 5px;
}

.Writing .Menu b {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  border: 3px solid gray;
  font-size: 0.5em;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
}

.Writing .Menu b:hover {
  border: 2px solid green;
  color: green;
}

.Writing .Menu i:hover {
  color: green;
}

.Writing form button {
  width: 10%;
  height: 50px;
  border-radius: 10px;
  background-color: aliceblue;
  font-size: 1em;
  font-weight: bolder;
}
</style>